import { animated, useSpring } from '@react-spring/three';
import { useGLTF } from '@react-three/drei';
import PropTypes from 'prop-types';
import React, { useRef } from 'react';

import BodyPoint from './body_point';

function HumanModel({ bodySettings, isFrontView, onMarkerClick, showMarkers }) {
	const { scene } = useGLTF('/assets/3d/human_body.glb');
	const group = useRef();

	const { rotationY } = useSpring({
		config: { friction: 26, mass: 1, tension: 170 },
		rotationY: isFrontView ? 0 : Math.PI, // Front = 0, Back = 180 degrees
	});

	return (
		<animated.group
			position={[0, 0.25, -0.2]}
			ref={group}
			rotation-y={rotationY}
		>
			<primitive object={scene} />

			{showMarkers &&
				(() => {
					let globalIndex = 0;

					return (isFrontView ? bodySettings.front : bodySettings.back).flatMap(
						(setting) =>
							setting.position.map((pos) => {
								const uniqueIndex = globalIndex++;

								return (
									<BodyPoint
										index={uniqueIndex}
										key={`${setting.id}-${uniqueIndex}`}
										onClick={() => onMarkerClick(setting)}
										position={pos}
									/>
								);
							}),
					);
				})()}
		</animated.group>
	);
}

export default HumanModel;

HumanModel.propTypes = {
	bodySettings: PropTypes.object,
	isFrontView: PropTypes.bool,
	onMarkerClick: PropTypes.func,
	showMarkers: PropTypes.bool,
};
